import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("A password tem de ter pelo menos 8 caracteres.");
    if (password !== confirm) return setError("As passwords nao coincidem.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setTimeout(() => nav("/login"), 800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Nao foi possivel redefinir.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-navy">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl p-8" data-testid="reset-form">
        <div className="text-blue uppercase text-xs font-semibold tracking-[0.2em] mb-2">Recuperacao</div>
        <h1 className="text-navy text-2xl font-bold tracking-tight mb-6">Redefinir password</h1>
        {!token && <div className="mb-4 px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm" data-testid="reset-notoken">Token em falta no URL.</div>}
        {error && <div className="mb-4 px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm" data-testid="reset-error">{error}</div>}
        <label className="block text-sm font-semibold text-navy mb-1">Nova password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8}
          data-testid="reset-password" className="w-full mb-3 px-4 py-2.5 border border-tint rounded-lg" />
        <label className="block text-sm font-semibold text-navy mb-1">Confirmar</label>
        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8}
          data-testid="reset-confirm" className="w-full mb-4 px-4 py-2.5 border border-tint rounded-lg" />
        <button type="submit" disabled={loading || !token} data-testid="reset-submit"
          className="w-full bg-blue text-white py-2.5 rounded-lg font-semibold disabled:opacity-50">
          {loading ? "A guardar..." : "Redefinir"}
        </button>
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-blue">Voltar ao login</Link>
        </div>
      </form>
    </div>
  );
}
